webpackJsonp([10],{

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Container = exports.Container = function (_React$Component) {
  _inherits(Container, _React$Component);

  function Container() {
    _classCallCheck(this, Container);

    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  _createClass(Container, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'container is-fluid is-gapless' },
        _react2.default.createElement(
          'section',
          { className: this.props.className },
          _react2.default.createElement(
            'div',
            { className: 'columns' },
            _react2.default.createElement(
              'div',
              { className: 'column' },
              this.props.children
            )
          )
        )
      );
    }
  }]);

  return Container;
}(_react2.default.Component);

Container.propTypes = {
  isHalf: _propTypes2.default.bool,
  children: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  className: _propTypes2.default.string
};

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footer = exports.Footer = function (_React$Component) {
  _inherits(Footer, _React$Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "container is-fullhd custom-footer-wrapper" },
        _react2.default.createElement(
          "div",
          { className: "custom-footer" },
          _react2.default.createElement(
            "p",
            null,
            "29 E. Madison St., Suite 500, Chicago, IL 60602 \u2022 312.701.1100"
          ),
          _react2.default.createElement(
            "p",
            null,
            "Securities offered through Cambridge Investment Research, Inc., a Broker/Dealer, Member FINRA / SIPC. Investment Advisory Services offered through Retirement Plan Advisors, LLC, a Federally Registered Investment Adviser. Cambridge is a partial owner of Retirement Plan Advisors, LLC. Registered representatives may only conduct business with residents of the states for which they are properly registered."
          )
        )
      );
    }
  }]);

  return Footer;
}(_react2.default.Component);

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldInput = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FieldInput = exports.FieldInput = function (_React$Component) {
  _inherits(FieldInput, _React$Component);

  function FieldInput() {
    _classCallCheck(this, FieldInput);

    return _possibleConstructorReturn(this, (FieldInput.__proto__ || Object.getPrototypeOf(FieldInput)).apply(this, arguments));
  }

  _createClass(FieldInput, [{
    key: 'renderInner',
    value: function renderInner() {
      var _props = this.props,
          type = _props.type,
          name = _props.name,
          value = _props.value,
          placeholder = _props.placeholder,
          required = _props.required,
          readOnly = _props.readOnly,
          onChange = _props.onChange;


      if (readOnly) {
        return value;
      } else {
        return _react2.default.createElement('input', { className: 'input',
          type: type,
          name: name,
          value: value,
          placeholder: placeholder,
          required: required,
          onChange: onChange });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'field' },
        _react2.default.createElement(
          'label',
          { className: 'label' },
          this.props.label
        ),
        _react2.default.createElement(
          'p',
          { className: 'control has-icons-left has-icons-right' },
          this.renderInner()
        )
      );
    }
  }]);

  return FieldInput;
}(_react2.default.Component);

FieldInput.propTypes = {
  label: _propTypes2.default.string,
  type: _propTypes2.default.string,
  name: _propTypes2.default.string,
  value: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  required: _propTypes2.default.bool,
  readOnly: _propTypes2.default.bool,
  onChange: _propTypes2.default.func
};

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldTextArea = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FieldTextArea = exports.FieldTextArea = function (_React$Component) {
  _inherits(FieldTextArea, _React$Component);

  function FieldTextArea() {
    _classCallCheck(this, FieldTextArea);

    return _possibleConstructorReturn(this, (FieldTextArea.__proto__ || Object.getPrototypeOf(FieldTextArea)).apply(this, arguments));
  }

  _createClass(FieldTextArea, [{
    key: 'renderInner',
    value: function renderInner() {
      var _props = this.props,
          name = _props.name,
          value = _props.value,
          placeholder = _props.placeholder,
          required = _props.required,
          readOnly = _props.readOnly,
          onChange = _props.onChange;


      if (readOnly) {
        return value;
      } else {
        return _react2.default.createElement('textarea', { className: 'textarea',
          name: name,
          value: value,
          placeholder: placeholder,
          required: required,
          onChange: onChange });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'field' },
        _react2.default.createElement(
          'label',
          { className: 'label' },
          this.props.label
        ),
        _react2.default.createElement(
          'p',
          { className: 'control has-icons-left has-icons-right' },
          this.renderInner()
        )
      );
    }
  }]);

  return FieldTextArea;
}(_react2.default.Component);

FieldTextArea.propTypes = {
  label: _propTypes2.default.string,
  name: _propTypes2.default.string,
  value: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  required: _propTypes2.default.bool,
  readOnly: _propTypes2.default.bool,
  onChange: _propTypes2.default.func
};

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminNavbar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AdminNavTab = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AdminNavbar = exports.AdminNavbar = function (_React$Component) {
  _inherits(AdminNavbar, _React$Component);

  function AdminNavbar() {
    _classCallCheck(this, AdminNavbar);

    return _possibleConstructorReturn(this, (AdminNavbar.__proto__ || Object.getPrototypeOf(AdminNavbar)).apply(this, arguments));
  }

  _createClass(AdminNavbar, [{
    key: 'render',
    value: function render() {
      var currentPage = this.props.currentPage;

      return _react2.default.createElement(
        'nav',
        { className: 'nav has-shadow is-admin' },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'nav-left' },
            _react2.default.createElement(
              'a',
              { className: 'nav-item' },
              'Administration:'
            ),
            _react2.default.createElement(_AdminNavTab.AdminNavTab, {
              url: '/categoryManagement',
              text: 'Categories',
              isActive: currentPage === 'categoryManagement' }),
            _react2.default.createElement(_AdminNavTab.AdminNavTab, {
              url: '/tagManagement',
              text: 'Tags',
              isActive: currentPage === 'tagManagement' }),
            _react2.default.createElement(_AdminNavTab.AdminNavTab, {
              url: '/userManagement',
              text: 'Users',
              isActive: currentPage === 'userManagement' }),
            _react2.default.createElement(_AdminNavTab.AdminNavTab, {
              url: '/documentManagement',
              text: 'Documents',
              isActive: currentPage === 'documentManagement' }),
            _react2.default.createElement(_AdminNavTab.AdminNavTab, {
              url: '/report',
              text: 'Reports',
              isActive: currentPage === 'report' })
          )
        )
      );
    }
  }]);

  return AdminNavbar;
}(_react2.default.Component);

AdminNavbar.propTypes = {
  currentPage: _propTypes2.default.string
};

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminNavTab = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AdminNavTab = exports.AdminNavTab = function (_React$Component) {
  _inherits(AdminNavTab, _React$Component);

  function AdminNavTab() {
    _classCallCheck(this, AdminNavTab);

    return _possibleConstructorReturn(this, (AdminNavTab.__proto__ || Object.getPrototypeOf(AdminNavTab)).apply(this, arguments));
  }

  _createClass(AdminNavTab, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isActive = _props.isActive,
          url = _props.url,
          text = _props.text;

      if (isActive) {
        return _react2.default.createElement(
          'a',
          { className: 'nav-item is-tab is-active', href: url },
          _react2.default.createElement(
            'span',
            { className: 'tag is-light' },
            text
          )
        );
      } else {
        return _react2.default.createElement(
          'a',
          { className: 'nav-item is-tab', href: url },
          _react2.default.createElement(
            'span',
            { className: 'tag is-white' },
            text
          )
        );
      }
    }
  }]);

  return AdminNavTab;
}(_react2.default.Component);

AdminNavTab.propTypes = {
  url: _propTypes2.default.string,
  text: _propTypes2.default.string,
  isActive: _propTypes2.default.bool
};

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(3);

var _NavTab = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Navbar = function (_React$Component) {
  _inherits(Navbar, _React$Component);

  function Navbar() {
    _classCallCheck(this, Navbar);

    return _possibleConstructorReturn(this, (Navbar.__proto__ || Object.getPrototypeOf(Navbar)).apply(this, arguments));
  }

  _createClass(Navbar, [{
    key: 'renderLogin',
    value: function renderLogin() {
      var _props = this.props,
          isLoggedIn = _props.isLoggedIn,
          currentPage = _props.currentPage;

      if (isLoggedIn) {
        return _react2.default.createElement(
          'a',
          { className: 'nav-item is-tab', href: '/logout' },
          'Logout'
        );
      } else {
        return _react2.default.createElement(_NavTab.NavTab, {
          show: true,
          url: '/login',
          text: 'Login',
          isActive: currentPage === 'login' });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          isLoggedIn = _props2.isLoggedIn,
          currentPage = _props2.currentPage;

      return _react2.default.createElement(
        'nav',
        { className: 'nav has-shadow' },
        _react2.default.createElement(
          'div',
          { className: 'container main-header' },
          _react2.default.createElement(
            'div',
            { className: 'nav-left' },
            _react2.default.createElement(
              'a',
              { className: 'nav-item', href: '/categories' },
              _react2.default.createElement('img', { className: 'md-logo', src: '/assets/img/logo.png', alt: 'logo' })
            ),
            _react2.default.createElement(_NavTab.NavTab, {
              show: isLoggedIn,
              url: '/categories',
              text: 'Categories',
              isActive: currentPage === 'categories' }),
            _react2.default.createElement(_NavTab.NavTab, {
              show: isLoggedIn,
              url: '/search',
              text: 'Search',
              isActive: currentPage === 'search' })
          ),
          _react2.default.createElement(
            'span',
            { id: 'nav-toggle', className: 'nav-toggle' },
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null)
          ),
          _react2.default.createElement(
            'div',
            { id: 'nav-menu', className: 'nav-right nav-menu' },
            _react2.default.createElement(_NavTab.NavTab, {
              show: true,
              url: 'https://www.cir2.com/',
              text: 'Cambridge',
              isActive: currentPage === 'cambridge' }),
            _react2.default.createElement(_NavTab.NavTab, {
              show: true,
              url: '/help',
              text: 'Help',
              isActive: currentPage === 'help' }),
            _react2.default.createElement(_NavTab.NavTab, {
              show: isLoggedIn,
              url: '/profile',
              text: 'Profile',
              isActive: currentPage === 'profile' }),
            _react2.default.createElement(_NavTab.NavTab, {
              show: !isLoggedIn,
              url: '/forgotPassword',
              text: 'Forgot password?',
              isActive: currentPage === 'forgotPassword' }),
            this.renderLogin()
          )
        )
      );
    }
  }]);

  return Navbar;
}(_react2.default.Component);

Navbar.propTypes = {
  currentPage: _propTypes2.default.string,
  isLoggedIn: _propTypes2.default.bool
};

exports.default = (0, _reactRedux.connect)(null)(Navbar);

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavTab = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavTab = exports.NavTab = function (_React$Component) {
  _inherits(NavTab, _React$Component);

  function NavTab() {
    _classCallCheck(this, NavTab);

    return _possibleConstructorReturn(this, (NavTab.__proto__ || Object.getPrototypeOf(NavTab)).apply(this, arguments));
  }

  _createClass(NavTab, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          show = _props.show,
          isActive = _props.isActive,
          url = _props.url,
          text = _props.text;

      if (show) {
        if (isActive) {
          return _react2.default.createElement(
            'a',
            { className: 'nav-item is-tab is-active', href: url },
            text
          );
        } else {
          return _react2.default.createElement(
            'a',
            { className: 'nav-item is-tab', href: url },
            text
          );
        }
      } else {
        return null;
      }
    }
  }]);

  return NavTab;
}(_react2.default.Component);

NavTab.propTypes = {
  show: _propTypes2.default.bool,
  url: _propTypes2.default.string,
  text: _propTypes2.default.string,
  isActive: _propTypes2.default.bool
};

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ACTION_ITEMS = {
  LOGIN: {
    REQUEST: 'LOGIN_REQUEST',
    SUCCESS: 'LOGIN_SUCCESS',
    FAILURE: 'LOGIN_FAILURE'
  }
};

exports.default = ACTION_ITEMS;

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _store = __webpack_require__(504);

var _store2 = _interopRequireDefault(_store);

var _Login = __webpack_require__(507);

var _Login2 = _interopRequireDefault(_Login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_reactDom2.default.render(_react2.default.createElement(
  _reactRedux.Provider,
  { store: _store2.default },
  _react2.default.createElement(_Login2.default, null)
), document.getElementById('app'));

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(10);

var _rootReducer = __webpack_require__(505);

var _rootReducer2 = _interopRequireDefault(_rootReducer);

var _reduxThunk = __webpack_require__(40);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxLogger = __webpack_require__(41);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _redux.createStore)(_rootReducer2.default, (0, _redux.applyMiddleware)((0, _reduxLogger.createLogger)(), _reduxThunk2.default));

exports.default = store;

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(10);

var _loginFormReducer = __webpack_require__(506);

exports.default = (0, _redux.combineReducers)({
  'loginForm': _loginFormReducer.loginFormReducer
});

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loginFormReducer = undefined;

var _actionItems = __webpack_require__(363);

var _actionItems2 = _interopRequireDefault(_actionItems);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  message: ''
};

var loginFormReducer = exports.loginFormReducer = function loginFormReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _actionItems2.default.LOGIN.FAILURE:
      state = Object.assign({}, state, { message: action.payload.message });
      break;

    default:
      break;
  }

  return state;
};

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(3);

var _components = __webpack_require__(6);

var _LoginForm = __webpack_require__(508);

var _LoginForm2 = _interopRequireDefault(_LoginForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Login = function (_React$Component) {
  _inherits(Login, _React$Component);

  function Login() {
    _classCallCheck(this, Login);

    return _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).apply(this, arguments));
  }

  _createClass(Login, [{
    key: 'render',
    value: function render() {
      var message = this.props.loginForm.message;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.Navbar, { currentPage: 'login', isLoggedIn: false, activePage: 'login' }),
        _react2.default.createElement(
          'div',
          { className: 'container is-fluid' },
          _react2.default.createElement(
            'section',
            null,
            _react2.default.createElement(
              'div',
              { className: 'columns' },
              _react2.default.createElement(
                'div',
                { className: 'column is-three-quarters is-login-column' },
                _react2.default.createElement(
                  'h1',
                  { style: { marginBottom: '30px' } },
                  'Retirement Plan Advisors \u2013 Advisor Website'
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'override-href' },
                  'Welcome to RPA\u2019s advisor website, where you can access the resources you need to deliver on Our Promise.',
                  _react2.default.createElement('br', null),
                  _react2.default.createElement('br', null),
                  'RPA\u2019s focus on public employees underscores a profound commitment',
                  _react2.default.createElement('br', null),
                  'and understanding of the people who make our communities work.',
                  _react2.default.createElement('br', null),
                  _react2.default.createElement('br', null),
                  'We never forget the person sitting across the table',
                  _react2.default.createElement('br', null),
                  'is depending on us to protect their hard-earned retirement.',
                  _react2.default.createElement('br', null),
                  _react2.default.createElement('br', null),
                  'We meet face to face with employees, year after year,',
                  _react2.default.createElement('br', null),
                  'as they continue to plan their retirement and future financial security.',
                  _react2.default.createElement('br', null),
                  _react2.default.createElement('br', null),
                  'We offer customized investment advice.',
                  _react2.default.createElement('br', null),
                  'As an independent firm, we have the freedom to design',
                  _react2.default.createElement('br', null),
                  'retirement solutions that are right for each individual.',
                  _react2.default.createElement('br', null),
                  _react2.default.createElement('br', null),
                  'We provide even the smallest communities with the same',
                  _react2.default.createElement('br', null),
                  'high-quality retirement plans and advice found on Wall Street.',
                  _react2.default.createElement('br', null),
                  'We act with integrity, respect and responsiveness to every individual.',
                  _react2.default.createElement('br', null),
                  _react2.default.createElement('br', null),
                  'Are you a Plan Sponsor or Plan Participant? Click',
                  ' ',
                  _react2.default.createElement(
                    'a',
                    { href: 'http://www.retirementplanadvisors.com/' },
                    'here'
                  ),
                  ' to be redirected to our public website.'
                )
              ),
              _react2.default.createElement(_LoginForm2.default, { message: message })
            )
          )
        ),
        _react2.default.createElement(_components.Footer, null)
      );
    }
  }]);

  return Login;
}(_react2.default.Component);

Login.propTypes = {
  loginForm: _propTypes2.default.shape({
    message: _propTypes2.default.string
  })
};

var mapStateToProps = function mapStateToProps(state) {
  var loginForm = state.loginForm;
  return { loginForm: loginForm };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Login);

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(3);

var _components = __webpack_require__(6);

var _postLoginUser = __webpack_require__(509);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginForm = function (_React$Component) {
  _inherits(LoginForm, _React$Component);

  function LoginForm(props) {
    _classCallCheck(this, LoginForm);

    // For testing only
    var _this = _possibleConstructorReturn(this, (LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call(this, props));

    _this.state = {
      username: '',
      password: ''
    };

    _this.handleSubmitLogin = _this.handleSubmitLogin.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  _createClass(LoginForm, [{
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'handleSubmitLogin',
    value: function handleSubmitLogin(target) {
      target.preventDefault();
      var data = {
        username: this.state.username,
        password: this.state.password
      };
      this.props.loginUser(data);
    }
  }, {
    key: 'renderMessage',
    value: function renderMessage() {
      if (this.props.message) {
        return _react2.default.createElement(
          'p',
          { className: 'help is-danger' },
          this.props.message
        );
      } else {
        return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'column is-primary' },
        _react2.default.createElement(
          'h3',
          null,
          'Access your account'
        ),
        _react2.default.createElement(
          'form',
          { action: '/login', method: 'post', onSubmit: this.handleSubmitLogin },
          _react2.default.createElement(_components.FieldInput, {
            label: 'Email address',
            type: 'email',
            name: 'username',
            value: this.state.username,
            placeholder: 'e.g. user@mail.com',
            required: true,
            onChange: this.handleChange }),
          _react2.default.createElement(_components.FieldInput, {
            label: 'Password',
            type: 'password',
            name: 'password',
            value: this.state.password,
            placeholder: '',
            required: true,
            onChange: this.handleChange }),
          this.renderMessage(),
          _react2.default.createElement(
            'div',
            { className: 'field' },
            _react2.default.createElement(
              'div',
              { className: 'control' },
              _react2.default.createElement(
                'button',
                { className: 'button is-info is-full-width' },
                'Login'
              )
            )
          ),
          _react2.default.createElement(
            'a',
            { className: 'is-full-width is-centered is-white', href: '/forgotPassword' },
            'Forgot password?'
          )
        )
      );
    }
  }]);

  return LoginForm;
}(_react2.default.Component);

LoginForm.propTypes = {
  message: _propTypes2.default.string,
  loginUser: _propTypes2.default.func
};

var mapDispathToProps = function mapDispathToProps(dispatch) {
  return {
    loginUser: function loginUser(data) {
      dispatch((0, _postLoginUser.postLoginUser)(data));
    }
  };
};

exports.default = (0, _reactRedux.connect)(null, mapDispathToProps)(LoginForm);

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postLoginUser = postLoginUser;

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _actionItems = __webpack_require__(363);

var _actionItems2 = _interopRequireDefault(_actionItems);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function postLoginUser(data) {
  return function (dispatch) {
    _axios2.default.post('/login', {
      username: data.username,
      password: data.password
    }).then(function (response) {
      if (response.data.message) {
        dispatch(postLoginUserFailure(response.data.message));
      } else {
        postLoginUserSuccess();
      }
    }).catch(function (error, response) {
      console.error(error);
    });
  };
};

function postLoginUserSuccess() {
  window.location = '/categories';
}

function postLoginUserFailure(message) {
  return {
    type: _actionItems2.default.LOGIN.FAILURE,
    payload: {
      message: message
    }
  };
}

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Navbar = exports.AdminNavbar = exports.FieldTextArea = exports.FieldInput = exports.Footer = exports.Container = undefined;

var _Container = __webpack_require__(20);

Object.defineProperty(exports, 'Container', {
  enumerable: true,
  get: function get() {
    return _Container.Container;
  }
});

var _Footer = __webpack_require__(21);

Object.defineProperty(exports, 'Footer', {
  enumerable: true,
  get: function get() {
    return _Footer.Footer;
  }
});

var _FieldInput = __webpack_require__(22);

Object.defineProperty(exports, 'FieldInput', {
  enumerable: true,
  get: function get() {
    return _FieldInput.FieldInput;
  }
});

var _FieldTextArea = __webpack_require__(23);

Object.defineProperty(exports, 'FieldTextArea', {
  enumerable: true,
  get: function get() {
    return _FieldTextArea.FieldTextArea;
  }
});

var _AdminNavbar = __webpack_require__(24);

Object.defineProperty(exports, 'AdminNavbar', {
  enumerable: true,
  get: function get() {
    return _AdminNavbar.AdminNavbar;
  }
});

var _Navbar = __webpack_require__(26);

var _Navbar2 = _interopRequireDefault(_Navbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Navbar = exports.Navbar = _Navbar2.default;

/***/ })

},[471]);


// WEBPACK FOOTER //
// login.min.js